<div class='e-btn-group' [formGroup]="form">
  @for (item of keyList; track item) {
    <input type="radio" [id]="id + '-' + item.value" formControlName="formValue" [value]="item.value"/>
    <label class="e-btn d-flex align-items-center" [ngClass]="{'fixed-width': fixedWidth, 'inline': inline }" [for]="id + '-' + item.value">{{ item.text | translate }}</label>
  }
</div>
